<template>
  <el-cascader ref="cascader" v-model="value"
               :options="options"
               :props="props"
               @change="change"
               :placeholder="placeholder"
               :style="css"
               :key="isResourceShow"
               filterable
               size="small"
               clearable>
  </el-cascader>
</template>

<script>
import { getProductSaleAreaList } from "@/api/product"
export default {
  name: "areaCas",
  props: {
    css: {
      type: Object,
      default: () => {
        return { width: "100%" };
      }
    },
    props: {
      type: Object,
      default: () => {
        return { expandTrigger: "hover" };
      }
    },
    placeholder: {
      type: String,
      default: "请选择区域"
    },
    deep: {
      type: Number,
      default: 0
    },
    fArray: {
      type: Array,
      default: () => {
        return [];
      }
    },
    shopId: [String,Number],
  },
  data() {
    return {
      value: "",
      options: [],
      isResourceShow: 0
    };
  },
  watch: {
    shopId: {
      deep: true,
      handler(val) {
        this.getList()
      }
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取分类
    getList() {
      getProductSaleAreaList({}).then( res=>{
        if(res.code == 0){
          let data= [];
          res.data.forEach(item => {
            item.value = item.id;
            item.label = item.name;
            item.level = 1;
            item.children = item.areasList;
            data.push(item);
            item.areasList.forEach(item2 => {
              item2.value = item2.id;
              item2.label = item2.name;
              item2.level = 2;
            });
          });
          ++this.isResourceShow;
          this.options = data;
        }
      })
    },
    change(value) {
      //取消已选中的
      if(Array.isArray(value)&&value.length==0){       // 多选 取消勾选
        this.options=this.setNoDisabled(this.options)
        this.$emit("getArea",value);
      }else{
        let a=this.$refs['cascader'].getCheckedNodes();
        if(this.props.multiple){    //多选
          let level=a.length==0?'':a[0].level;
          this.options=this.setLevelDisabled(this.options,level)
          this.$emit("getArea",value,a[0].level);
        }else{                    //单选
          let name=a.length==0?'':a[0].label
          this.$emit("getArea",value,name);
        }

      }

    },
    reset() {
      this.value = "";
      ++this.isResourceShow;
      this.options=this.setNoDisabled(this.options)
      this.$refs.cascader.handleClear();
    },
    setLevelDisabled(data,level){
      let tree = [];
      data.forEach(item => {
        if (item.level != level) {
          item.disabled = true
        }
        item.children&&this.setLevelDisabled(item.children,level)
        tree.push(item)
      })
      return tree;
    },
    setNoDisabled(data){
      let tree = [];
      data.forEach(item => {
        // console.log(item.children);
        item.disabled = false
        item.children&&this.setNoDisabled(item.children)
        tree.push(item)
      })
      return tree;


    }

  }
};
</script>




// WEBPACK FOOTER //
// src/components/AreaSelect/index.vue